/**
 * 密码各个部分的验证状态
 */
interface PasswordRequirementStatus {
  length: boolean
  uppercase: boolean
  lowercase: boolean
  number: boolean
  special: boolean
}

/**
 * 批量检查密码规则并返回详细状态
 */
export function checkPasswordRequirements(
  password: string,
): PasswordRequirementStatus {
  const specialCharacters = '!@#$%^&*(),.?":{}|[]\\-+=~<>/\'`'

  return {
    length:
      password.length >= 8 && password.length <= 16 && !password.includes(' '),
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: Array.from(password).some((char) =>
      specialCharacters.includes(char),
    ),
  }
}

/**
 * 验证密码是否符合业务规则
 * 规则：8-16位，包含大写字母、小写字母、数字和特殊字符，且不能包含空格
 * 如果验证通过，返回 null，否则返回对应的错误提示
 */
export function getPasswordError(password: string): string | null {
  // 保持原有的错误优先顺序：1. 长度校验 2. 空格校验 3. 字符类型校验
  if (password.length < 8 || password.length > 16) {
    return 'Password must be 8-16 characters long'
  }

  if (password.includes(' ')) {
    return 'Password cannot contain spaces'
  }

  const status = checkPasswordRequirements(password)
  if (
    !status.uppercase ||
    !status.lowercase ||
    !status.number ||
    !status.special
  ) {
    return 'Password must contain uppercase, lowercase, numbers and special characters'
  }

  return null
}
